/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CafAssign } from '../models';
/**
 * CafApi - axios parameter creator
 * @export
 */
export const CafApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {CafAssign} [cafAssign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cafAssign: async (cafAssign?: CafAssign, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/caf/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cafAssign, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CafApi - functional programming interface
 * @export
 */
export const CafApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CafApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {CafAssign} [cafAssign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cafAssign(cafAssign?: CafAssign, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cafAssign(cafAssign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CafApi.cafAssign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CafApi - factory interface
 * @export
 */
export const CafApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CafApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {CafAssign} [cafAssign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cafAssign(cafAssign?: CafAssign, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cafAssign(cafAssign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CafApi - interface
 * @export
 * @interface CafApi
 */
export interface CafApiInterface {
    /**
     * 
     * @summary Assign practice to operator
     * @param {CafAssign} [cafAssign] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafApiInterface
     */
    cafAssign(cafAssign?: CafAssign, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CafApi - object-oriented interface
 * @export
 * @class CafApi
 * @extends {BaseAPI}
 */
export class CafApi extends BaseAPI implements CafApiInterface {
    /**
     * 
     * @summary Assign practice to operator
     * @param {CafAssign} [cafAssign] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CafApi
     */
    public cafAssign(cafAssign?: CafAssign, options?: RawAxiosRequestConfig) {
        return CafApiFp(this.configuration).cafAssign(cafAssign, options).then((request) => request(this.axios, this.basePath));
    }
}

